import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { StoreProvider } from './app/providers/StoreProvider/index.js'

import App from './app/App.jsx'

import './index.css'


createRoot(document.getElementById('root')).render(
  <StoreProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StoreProvider>
)
